import { AISkeleton } from 'ai-components-ui-library/components/loading/AISkeleton';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const QuizMeLoading = () => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "ai-quiz-me-generation-loading",
    children: [/*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "40px",
        width: "10%"
      })
    }), /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "25px",
        width: "65%"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "50px",
        shape: "pill",
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "50px",
        shape: "pill",
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "50px",
        shape: "pill",
        width: "100%"
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlock: "200",
      children: /*#__PURE__*/_jsx(AISkeleton, {
        height: "50px",
        shape: "pill",
        width: "100%"
      })
    })]
  });
};
export default QuizMeLoading;